import { Component, OnInit } from '@angular/core';
import { DwMdSectionConfigBaseComponent2, DwComponentSectionConfigPreference, DwMdItem } from '@devwareapps/devware-cap';
import { FileControlConfig } from '../../models/file-control-config.model';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-file-control-config',
  templateUrl: './file-control-config.component.html',
  styleUrls: ['./file-control-config.component.scss']
})
export class FileControlConfigComponent
  extends  DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<FileControlConfig>> {

  configFormGroup: FormGroup;
  itemMetaData: DwMdItem;

  setupForm() {
    // Add config fields to the form

    this.configFormGroup = new FormGroup({
      attachmentId: new FormControl(),
    });

    this.formGroup.addControl('config', this.configFormGroup);

  }


  setupAttributeList() {
    this.getItemMetaData(this.itemName)
      .subscribe(itemMetaData => {
        this.itemMetaData = itemMetaData;
      });
  }

}
